import axios from 'axios'
import { error, alertMsg } from '../theme/element';
import { toAny } from '../utils/toany';
import { commitState, readState } from './state';
import { openRoutePage } from './router';
import { getConfig } from './config'
import { inPc } from './bridge';
import { genUrl } from '../utils/query';
import { hex_md5 } from '../utils/md5';

if (!window.__injectAxiosConfig) {
    window.__injectAxiosConfig = true;
    axios.defaults.timeout = 100000;
    axios.defaults.headers['Content-Type'] = 'application/json';
}

function getDisposition(headers) {
    if (headers && headers['content-disposition']) {
        return `${headers['content-disposition']}`.replace("attachment;filename=", "");
    }
}

function handleResponse(dataResponse) {
    let resData = toAny(dataResponse, {});
    if (resData.code !== 0) {
        if (resData.code == 103) {
            commitState({ accessToken: "", accessLoggedIn: false, userInfo: {} });
            setTimeout(() => { openRoutePage("/login"); }, 0);
        }
        throw resData;
    }
    return resData;
}

function handleDownloadResponse(res, file) {
    const { data, headers } = res
    let fileName = file || getDisposition(headers);
    if (!fileName) {
        if (data instanceof Blob) {
            return data.text().then((dataResponse) => {
                return handleResponse(dataResponse);
            })
        }
        return;
    }
    const blob = new Blob([data])
    if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
    } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName)
    }
}

/**
 * 网络请求
 * @param {*} action
 * @param {*} params
 * @param {*} opts
 * @returns
 */
export function requestApi(action, params = {}, opts = {}) {
    if (!action) {
        throw new Error("action is required");
    }
    if (opts && opts.download) {
        opts.responseType = 'blob';
        opts.timeout = 0;
    }
    if (opts && opts.upload) {
        opts.timeout = 0;
    }
    if (opts.newWindowDownload) {
        let downloadUrl = genUrl(`${getConfig('API_SERVER')}`, Object.assign({
            action: action,
            token: readState('accessToken'),
        }, params, { platform: inPc() ? "pc" : "web" }));
        window.open(downloadUrl);
        return Promise.resolve();
    }
    let url = `${getConfig('API_SERVER')}?action=${encodeURIComponent(action)}`;
    let cacheKey = `__request_cache_${hex_md5(url + JSON.stringify(params))}`;
    let cacheFlag = opts && !opts.download && opts.cache;
    if (cacheFlag) {
        try {
            let cacheData = JSON.parse(localStorage.getItem(cacheKey));
            opts.cacheCallback && opts.cacheCallback(cacheData)
        } catch (error) {
        }
    }
    return axios.post(url, JSON.stringify({
        token: readState('accessToken'),
        params: Object.assign({}, params, {
            curStoreGuid: readState("curStoreGuid", ""),
            platform: inPc() ? "pc" : "web"
        })
    }), opts).then(res => {
        if (opts && opts.download) {
            return handleDownloadResponse(res, opts.fileName);
        } else {
            return handleResponse(res.data);
        }
    }).then((resp) => {
        if (cacheFlag) {
            try {
                localStorage.setItem(cacheKey, JSON.stringify(resp));
            } catch (e) {
            }
        }
        return resp;
    }).catch(err => {
        if (cacheFlag) {
            try {
                localStorage.setItem(cacheKey, "");
            } catch (e) {
            }
        }
        if (opts && opts.showAlert) {
            alertMsg((err && (err.msg)) || "连接服务器失败，请检查网络");
        } else if (opts && opts.showError) {
            error((err && (err.msg)) || "连接服务器失败，请检查网络");
        }
        throw err;
    });
}
